define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
   $resource(
        "#{RENTAPPLICATION_API_URL}/api/v1/landlord/:id/",
        {},
        {
          get:
            cache: true
          getMe:
            cache: true
            url: "#{RENTAPPLICATION_API_URL}/api/v1/landlord/me/"
          update:
            url: "#{RENTAPPLICATION_API_URL}/api/v1/landlord/:id/"
            method: 'PATCH'
            params:
              id: "@id"
          remove_card:
            url: "#{RENTAPPLICATION_API_URL}/api/v1/landlord/remove_card/"
            method: 'POST'
          enable_sms:
            url: "#{RENTAPPLICATION_API_URL}/api/v1/landlord/enable_sms/"
            method: 'POST'
        }
      )



// WEBPACK FOOTER //
// ./resources/Landlord.coffee